function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Testimonial from "segments/desktop/core-components/testimonial/testimonial";
import AssetComponent from "components/core/asset/asset-component";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import StatisticComponent from "segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/components/statistic/statistic-component";
import { StyledTabContentComponent } from "./tab-content-component.scss";
const TabContentComponent = ({ testimonial, asset, stats, tabAdvancedConfig, advancedAssetProps })=>{
    var _testimonial_button, _testimonial_button1, _testimonial_button2;
    return /*#__PURE__*/ _jsxs(StyledTabContentComponent, {
        testimonialMaxWidth: tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.testimonialMaxWidth,
        className: "tab-content-component",
        children: [
            /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset, advancedAssetProps)),
            /*#__PURE__*/ _jsxs("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "testimonial-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx(Testimonial, _object_spread({}, testimonial)),
                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.button) && /*#__PURE__*/ _jsx(SecondaryButton, {
                                isWithArrow: true,
                                color: (_testimonial_button = testimonial.button) === null || _testimonial_button === void 0 ? void 0 : _testimonial_button.color,
                                url: (_testimonial_button1 = testimonial.button) === null || _testimonial_button1 === void 0 ? void 0 : _testimonial_button1.buttonUrl,
                                buttonText: (_testimonial_button2 = testimonial.button) === null || _testimonial_button2 === void 0 ? void 0 : _testimonial_button2.buttonText,
                                isOpenLinkInNewTab: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "stats-section",
                        children: stats === null || stats === void 0 ? void 0 : stats.map((statics, index)=>/*#__PURE__*/ _jsx(StatisticComponent, {
                                advancedStaticsConfig: tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.advancedStatsConfig,
                                statics: statics
                            }, index))
                    })
                ]
            })
        ]
    });
};
export default TabContentComponent;
